// Card.js
import React from 'react';
import styles from '../styles/NewsCard.module.css'; // CSS Module import

const NewsCard = ({ image, icon, title, description, active,onClick }) => {
    return (
      <div className={`${styles.card} ${active ? styles.active : ''}`}>
        <div className={styles.imageWrapper}>
          <img src={image} alt={title} className={styles.cardImage} />
        </div>
        {icon&&<div className={styles.iconWrapper}>
            <div className={styles.iconCircle}>
                {icon}
            </div>
        </div>}
        <div className={styles.content}>
          <h3>{title}</h3>
          <p>{description}</p>
          <span onClick={onClick} className={styles.link}>Learn more <span>→</span></span>
        </div>
      </div>
    );
  };

export default NewsCard;


// https://images.unsplash.com/photo-1506748686214-e9df14d4d9d0?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=800&q=80